import React, { useState } from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const SearchBar = ({ onSearch }) => {
    const [searchValue, setSearchValue] = useState('');

    const handleSearchChange = (event) => {
        setSearchValue(event.target.value);
    };

    const handleSearchSubmit = () => {
        if (onSearch) {
            onSearch(searchValue);
        }
    };
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            if (onSearch) {
                onSearch(searchValue);
            }
        }
    };

    return (
        <TextField
            fullWidth
            variant="outlined"
            size="small"
            placeholder="جستجو کنید..."
            value={searchValue}
            onChange={handleSearchChange}
            onKeyDown={handleKeyPress}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton onClick={handleSearchSubmit}>
                            <SearchIcon />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            sx={{
                backgroundColor: '#fff',
                borderRadius: '5px',
            }}
        />
    );
};

export default SearchBar;
